// Register the service worker so Bricknote is installable as a PWA and can show
// an offline fallback. Staging uses the production bundle too, but its HTTP
// Basic Auth gate is incompatible with a worker-controlled navigation. Rails
// renders a runtime marker so staging can remove workers left by older deploys.
// The worker itself is served by Rails at /service-worker (see config/routes.rb
// and app/views/pwa/service-worker.js).
const RELOAD_FLAG = "bricknote-sw-cleanup-reloaded"

if (import.meta.env.PROD && "serviceWorker" in navigator) {
  const setting = document.querySelector(
    'meta[name="bricknote-service-worker"]',
  )?.content

  if (setting === "disabled") {
    disableServiceWorker().catch((error) => {
      console.error("Service worker cleanup failed:", error)
    })
  } else if (setting === "enabled") {
    window.addEventListener("load", () => {
      navigator.serviceWorker.register("/service-worker", { scope: "/" }).catch((error) => {
        console.error("Service worker registration failed:", error)
      })
    })
  }
}

async function disableServiceWorker() {
  const wasControlled = navigator.serviceWorker.controller !== null
  // Not getRegistration("/") - earlier deploys may have claimed another scope,
  // and a missed registration is one this cleanup can never reach again.
  const registrations = await navigator.serviceWorker.getRegistrations()

  await Promise.all(registrations.map((registration) => registration.unregister()))

  if ("caches" in window) {
    const cacheNames = await caches.keys()
    await Promise.all(
      cacheNames
        .filter((name) => name.startsWith("bricknote-"))
        .map((name) => caches.delete(name)),
    )
  }

  // unregister() only changes subsequent navigations. Reload once so this tab
  // is no longer controlled by the worker that was active when it loaded.
  // Strictly one-shot: if a registration outlives the cleanup (partitioned
  // storage hides it from getRegistrations, or unregister fails), the reloaded
  // document is controlled again and an unguarded reload would loop forever.
  if (wasControlled && !sessionStorage.getItem(RELOAD_FLAG)) {
    sessionStorage.setItem(RELOAD_FLAG, "1")
    window.location.reload()
  }
}
